import $ from 'jquery';
import 'magnific-popup';
import '../Language/magnific-popup'

(function () {
    var lightboxes = $('a.lightbox');
    if (lightboxes.length === 0) {
        return;
    }

    lightboxes.magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        },
        zoom: {
            enabled: true,
            easing: 'ease-in-out'
        }
    });
})();


(function () {
    var $lightboxGroup = $('.lightbox-group');
    if ($lightboxGroup.length === 0) {
        return;
    }

    $lightboxGroup.magnificPopup({
        type: 'image',
        delegate: 'a',
        gallery: {
            enabled: true
        },
        zoom: {
            enabled: true,
            easing: 'ease-in-out'
        }
    });
})();
